import angular from "angular";
import component from "./daily-report.component";

angular.module('dailyReport', [component]);

export default "dailyReport";


// WEBPACK FOOTER //
// ./resources/assets/modules/daily-report/daily-report.module.js